
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.889 5.111H3.556A1.556 1.556 0 002 6.667v3.11m3.889-4.666h6.222m-6.222 0V3.556A1.556 1.556 0 017.444 2h3.112a1.556 1.556 0 011.555 1.556V5.11M2 9.778v4.666A1.556 1.556 0 003.556 16h10.888A1.556 1.556 0 0016 14.444V9.778m-14 0h14M12.111 5.11h2.333A1.556 1.556 0 0116 6.667v3.11","stroke":"currentColor","stroke-width":"1.75","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    